<template>
    <div>
        <Form
            :model="searchItem"
            :label-width="100"
            label-position="left"
            :disabled="modal_loading"
            ref="formValidate" 
            :show-message="false"
            style="margin-top:20px"
        >
            <Row style="margin-bottom: 0">
                <Col span="5">
                <FormItem label="离职人">
                    <Input v-model="searchItem.userName" />
                </FormItem>
                </Col>
                <Col span="5" offset="1">
                <FormItem label="申请单状态" >
                    <Select clearable v-model="searchItem.status"  >
                        <Option
                        v-for="(item, i) in ApplyStatus"
                        :value="item.code"
                        :key="i"
                        >{{ item.name }}</Option
                        >
                    </Select>
                </FormItem>
                </Col>
                <Col span="1" offset="1">
                <Button type="primary" @click="totalNum=0,pageInfo.pageNo=1,getData()">{{$t('query')}}</Button>
                </Col>
            </Row>
        </Form>
        <Table
              style="margin-top: 20px;"
              stripe
              border
              :columns="columns1"
              :loading="modal_loading"
              :data="dataTable"
            >
            <template slot="slot1" slot-scope="{ row }">
                <div>
                  <Icon
                    @click="showExitMatter(row)"
                    type="md-eye"
                    style="font-size: 30px;"
                    color="rgb(33,181,245)"
                  ></Icon>
                </div>
            </template>
        </Table>
         <Page :total="totalNum" style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:-10px" @on-change="pageChange" /> 
        <Modal v-model="showMatter" title="确认事项" width="1380px" >
            <div>{{ $t("查询条件") }}</div>
                <Form :model="formInline" inline :label-width="50" label-position="left">
                <FormItem label="事项 " :label-width="60">
                    <Select v-model="searchItem.item_word_text" filterable clearable style="width: 260px;">
                        <Option
                        v-for="(item, index) in wordText"
                        :value="item.item_word_text"
                        :key="index"
                        >{{ item.item_word_text }}</Option
                    >
                    </Select>
                </FormItem>
                <Button type="primary"  @click="matterTotal=0,pageInfoMatter.pageNo=1,getExitMatter()">查询</Button>
                </Form>
                <Table border ref="myTable" :columns="columns2" :data="data1" :loading="loading" style="height: 520px;">
                    <template slot-scope="{ row }" slot="file1">
                        <span style="cursor: pointer;" @click="$donwLoad(row.attachment)">{{row.resource_name}}</span>
                    </template>
                <template slot-scope="{ row, index }" slot="slot1">
                    <Button
                    type="primary"
                    size="small"
                    style="margin-right: 5px"
                    @click="select1(row, index)"
                    >操作</Button>
                </template>
                </Table>
                <Page style="margin-top: 20px; text-align: right" :total="matterTotal" @on-change="pageChangeMatter"/>
                <div slot="footer"></div>
          </Modal>

          <Modal v-model="showUpdateMatter" title="编辑" width="600px">
                <Form :model="formInline" inline :label-width="60" label-position="left">
                <Row> 
                    <Col span="24" class="rowBox">
                        <FormItem label="备注" >
                            <Input style="width: 300px;" type="textarea" placeholder="" :rows="4"  v-model="searchItem.comment"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24" class="rowBox">
                    <FormItem :label="$t('附件')">
                        <!-- <j2-FileUP ref="file" v-if="!getQueryVariable('history')" @handleOK="fileSuc" @handleDel="fileDel" :file_type="{resourceType:''}"></j2-FileUP> -->
                        <!-- <label v-if="getQueryVariable('history')" style="cursor:pointer"  @click="download()">{{formItem.sename}}</label>   -->
                        <j2-FileUP ref="file1" @handleDel="fileDel" @handleOK="fileSuc" :file_type="{resourceType:'Exit_Matter'}" :resourceId="formItem.attachment"></j2-FileUP>
                    </FormItem>
                    </Col>
                </Row>
                </Form>
            <div slot="footer">
                <Button type="text" @click="updateMatterInfo">确认</Button>
                <Button type="text" @click="closeShowUpdateMatter">取消</Button>
            </div>
          </Modal>
        <!-- <Page :total="this.totalNum" style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:-10px" @on-change="pageChange" /> -->
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            showUpdateMatter:false,
            loading:false,
            showMatter : false,
            date: new DateUtil(),
            formInline:{},
            instance:"",
            resourceId_List:[],
            searchItem:{
                serialnumber:'',
                userName:''
            },
            ApplyStatus:[
                {
                    code : 0,
                    name : "申请中"
                },
                {
                    code : 7,
                    name : "申请撤销"
                },
                {
                    code : 8,
                    name : "申请通过"
                },
                {
                    code : 9,
                    name : "申请驳回"
                }
            ],
            modal_loading:false,
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            matterTotal: 0, //table数据总条数
            pageInfoMatter: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            columns1: [
                {
                    title: '申请单号',
                    key: 'applyNo',
                    align: "center"
                },
                {
                    title: '员工工号',
                    key: 'applyUserId',
                    align: "center"
                },
                {
                    title: '离职人',
                    key: 'userName',
                    align: "center"
                },
                {
                    title: '离职人职位',
                    key: 'title_position',
                    align: "center"
                },
                {
                    title: '申请单状态',
                    key: 'status',
                    align: "center"
                },
                {
                    title: '详情',
                    align: "center",
                    slot: "slot1"
                },
            ],
            dataTable:[
            ],
            columns2:[
            {
                    title: '事项',
                    key: 'item_word_text',
                    align: "center",
                    width : 300
                },
                {
                    title: '确认人',
                    key: 'be_sure_user',
                    align: "center",
                    width : 100
                },
                {
                    title: '确认时间',
                    key: "be_sure_time",
                    align: "center",
                    width : 130
                },
                {
                    title: '确认部门',
                    key: 'matter_department',
                    align: "center",
                    width : 100
                },
                {
                    title: '备注',
                    key: 'comment',
                    align: "center",
                    width : 300
                },
                {
                    title: '附件',
                    key: "resource_name",
                    align: "center",
                    slot:'file1',
                    width : 300
                },
                
                {
                    title: '操作',
                    align: "center",
                    slot: "slot1",
                    width : 115,
                },
            ],
            data1:[],
            dataList:[],
            dataListName:[],
            formItem:{},
            roleList:[],
            wordText:[],
            loginRole:"",
        }
    },
    watch:{
        'showMatter'(val){
            if(!val){
                this.searchItem.item_word_text = ''
            }
        }
    },
    created(){
        this.getRole()
        this.getData()

    },
    methods:{
        getRole(){
            let Obj = {
                userID : JSON.parse(window.sessionStorage.getItem("userInfo")).userId,
            }
            axios.post("/RoleRelation/loginRoleRelation", Obj).then((res) => {
                this.roleList=res
                var idsStr = this.roleList.map(function(obj,index){
                    return obj.roleId;
                }).join(",");
                this.loginRole = idsStr
                this.selectWordText()
            })
        },
        selectWordText(){
            let Obj = {
                matter_department : this.loginRole
            }
            axios.post("/ExitMatter/selectExitWordText", Obj).then((res) => {
                this.wordText = res
            })
        },
        getExitMatter(){
            let Obj={
            pageNo:this.pageInfoMatter.pageNo,
            pageSize : this.pageInfoMatter.pageSize,
            instanceId : this.instance,
            item_word_text : this.searchItem.item_word_text,
            matter_department : this.loginRole
            }
            this.loading=true;
            axios.post("/ExitMatter/selectExitMatterInfo", Obj).then((res) => {
                this.data1= res.data 
                for(let i=0;i<this.data1.length;i++){
                    this.data1[i].be_sure_time ? this.data1[i].be_sure_time = this.date.dateVal(this.data1[i].be_sure_time,"YYYY/MM/DD") : '' 
                }
                this.matterTotal=parseInt(res.pageInfo.total)
                this.loading=false;
            });
        },
        getData(){
            let Obj = {
                pageNo:this.pageInfo.pageNo,
                pageSize : this.pageInfo.pageSize,
                userName : this.searchItem.userName,
                status : this.searchItem.status
            };
            this.modal_loading = true
        axios.post("/Exit/selectExitMatterInfo", Obj).then((res) => {
            this.dataTable=res.data
            this.totalNum = parseInt(res.pageInfo.total)
            this.modal_loading = false
        }); 
        },
        showExitMatter(row){
            this.showMatter = true 
            this.instance = row.instanceId
            this.getExitMatter()
        },
        pageChangeMatter(val){
            this.pageInfoMatter.pageNo = val
            this.getExitMatter();
        },
        pageChange(val){
            this.pageInfo.pageNo = val
            this.getData();
        },
        select1(row,index){
            this.showUpdateMatter = true
            this.searchItem.comment = row.comment
            this.formItem.id = row.id
            this.formItem.instanceId = row.instanceId
            this.$refs['file1'].setFileInfo(
                row.attachment,
                row.resource_name
            )
       
        },
        // 删除附件
        fileDel(res_id) {
            this.searchItem.attachment = "";
            this.resourceId_List.push(res_id);
        },
        // 离职补偿金附件、
        fileSuc(res_id) {
            this.searchItem.attachment = res_id;
        },
        updateMatterInfo(){
            this.$Modal.confirm({
                title: this.$notice('sureSave'),
                content: "",
                onOk: () => {
                    this.submit()
                    this.showUpdateMatter=false
                },
                onCancel: () => {},
             });
        },
        submit(){
            let Obj={
                id:this.formItem.id,
                instanceId:this.formItem.instanceId,
                be_sure_user : JSON.parse(window.sessionStorage.getItem("userInfo")).userName,
                be_sure_time : new Date(),
                comment : this.searchItem.comment,
                be_sure_serialnumber : JSON.parse(window.sessionStorage.getItem("userInfo")).serialnumber,
                attachment:this.searchItem.attachment
            }
            axios.post("/ExitMatter/updateExitMatterInfo",Obj).then((res) => {
                this.getExitMatter()
            });
        },
        closeShowUpdateMatter(){
            this.showUpdateMatter=false
        }
        }
}
</script>

<style lang="less">
.ivu-modal-body {
    max-height: calc(100vh - 200px - 51px);
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/ExitMatter.vue